import { memo } from 'react'

// import { OnlyOfficeEmbeddedView } from 'cluster_office/exposed'

// import { useItemModal } from '../../hooks/useItemModal'

export const ClusterOfficeEmbeddedView = memo(() => {
  // const { itemId } = useItemModal()
  // return itemId ? <OnlyOfficeEmbeddedView itemId={itemId} /> : <></>
  return <div>ClusterOfficeEmbeddedView</div>
})
